<template>
  <div />
</template>

<script>
import asControl from "@/components/mapbox/mixins/asControl";
import { mapIcons, createSvgIcon } from "@/assets/icons/mapIcons";

export default {
  name: "VesselFilterControl",
  mixins: [asControl],
  props: {
    position: {
      type: String,
      default: "top-left",
    },
    onFilterChange: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isOpen: false,
      selectedFilters: {
        low: true,
        medium: true,
        high: true,
        critical: true,
        unknown: true,
      },
    };
  },
  mounted() {
    this.createControl();
    this.$_addControl();
  },
  methods: {
    createControl() {
      // Create main container
      this.controlContainer = document.createElement("div");
      this.controlContainer.className =
        "mapboxgl-ctrl mapboxgl-ctrl-group vessel-filter-control";

      // Create toggle button
      this.toggleButton = document.createElement("button");
      this.toggleButton.className = "mapboxgl-ctrl-icon filter-toggle-button";
      this.toggleButton.type = "button";
      this.toggleButton.title = "Filter Vessels by Fouling";
      this.toggleButton.innerHTML = createSvgIcon(mapIcons.filter);

      // Create filter panel
      this.filterPanel = document.createElement("div");
      this.filterPanel.className = "filter-panel";
      this.filterPanel.style.display = "none";
      this.filterPanel.innerHTML = `
        <div class="filter-header">
          <span>Filter by Fouling Level</span>
        </div>
        <div class="filter-options">
          <label class="filter-option">
            <input type="checkbox" data-filter="low" checked>
            <span class="filter-color low"></span>
            <span>Low (0.0-1)</span>
          </label>
          <label class="filter-option">
            <input type="checkbox" data-filter="medium" checked>
            <span class="filter-color medium"></span>
            <span>Medium (1-4)</span>
          </label>
          <label class="filter-option">
            <input type="checkbox" data-filter="high" checked>
            <span class="filter-color high"></span>
            <span>High (4-8)</span>
          </label>
          <label class="filter-option">
            <input type="checkbox" data-filter="critical" checked>
            <span class="filter-color critical"></span>
            <span>Critical (>8)</span>
          </label>
          <label class="filter-option">
            <input type="checkbox" data-filter="unknown" checked>
            <span class="filter-color unknown"></span>
            <span>Unknown</span>
          </label>
        </div>
      `;

      // Add event listeners
      this.toggleButton.addEventListener("click", this.togglePanel);
      this.filterPanel.addEventListener("change", this.handleFilterChange);

      // Append elements
      this.controlContainer.appendChild(this.toggleButton);
      this.controlContainer.appendChild(this.filterPanel);

      // Set up the control
      this.control = {
        onAdd: () => this.controlContainer,
        onRemove: () => {
          if (this.controlContainer.parentNode) {
            this.controlContainer.parentNode.removeChild(this.controlContainer);
          }
        },
        getDefaultPosition: () => this.position,
      };
    },

    togglePanel() {
      this.isOpen = !this.isOpen;
      this.filterPanel.style.display = this.isOpen ? "block" : "none";
      this.toggleButton.classList.toggle("active", this.isOpen);
    },

    handleFilterChange(event) {
      if (event.target.type === "checkbox") {
        const filterType = event.target.dataset.filter;
        this.selectedFilters[filterType] = event.target.checked;
        this.onFilterChange(this.selectedFilters);
      }
    },
  },
};
</script>

<style>
.vessel-filter-control {
  background: white;
  border-radius: 4px;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
  position: relative;
}

.filter-toggle-button {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 29px;
  height: 29px;
  color: #404040;
  transition: all 0.2s ease;
}

.filter-toggle-button:hover,
.filter-toggle-button.active {
  background-color: #f0f0f0;
  color: #000;
}

.filter-panel {
  position: absolute;
  top: 0;
  right: 100%;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  z-index: 1000;
  margin-right: 5px;
}

.filter-header {
  padding: 12px;
  border-bottom: 1px solid #eee;
  font-weight: 600;
  font-size: 14px;
  color: #333;
}

.filter-options {
  padding: 8px;
}

.filter-option {
  display: flex;
  align-items: center;
  padding: 6px 8px;
  cursor: pointer;
  border-radius: 3px;
  transition: background-color 0.2s ease;
}

.filter-option:hover {
  background-color: #f8f9fa;
}

.filter-option input[type="checkbox"] {
  margin-right: 8px;
}

.filter-color {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.filter-color.low {
  background: linear-gradient(135deg, #2ecc71 0%, #27ae60 100%) !important;
}

.filter-color.medium {
  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%) !important;
}

.filter-color.high {
  background: linear-gradient(135deg, #f39c12 0%, #e67e22 100%) !important;
}

.filter-color.critical {
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%) !important;
}

.filter-color.unknown {
  background: linear-gradient(135deg, #95a5a6 0%, #7f8c8d 100%) !important;
}

.filter-option span:last-child {
  font-size: 13px;
  color: #555;
}
</style>
